import RadioField from '../../shared/RadioField'
import { EMPTY_RADIO_OPTION } from 'store/CreatePropertyAdSlice/constants'
import { Option } from 'store/CreatePropertyAdSlice/types'
import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../..'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues?: UseFormGetValues<FormValues>
  resetField?: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}
export const YES_RADIO_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.radio.yes.label',
  value: 'fire_safety',
}
export const NO_RADIO_OPTION: Option = {
  label: 'manageEstateAd.steps.estateCategory.radio.no.label',
  value: 'fire_safety_no',
}

const FireSafety = (props: Props) => {
  const { control } = props
  return (
    <>
      <RadioField
        options={[YES_RADIO_OPTION, NO_RADIO_OPTION, EMPTY_RADIO_OPTION]}
        title="createPropertyAdFields.fireSafety.label"
        translateTitle
        titleProps={{ required: false }}
        control={control}
        name={'property.extras.fireSafety' as Path<FormValues>}
      />
    </>
  )
}

export default FireSafety
